import { createTheme }  from '@material-ui/core/styles'
const beneficiaryTheme = createTheme({
  overrides: {
    MuiCard: {
      root: {
        marginBottom: '10px'
      },
      elevation: 0
    },
  }
})
export default beneficiaryTheme

export const PARCEL_STATUS_COLOURS = {
    ready_to_go: "#fff9c4",
    picking: "#eceff1",
    in_transit: "#bbdefb",
    complete: "#c8e6c9",
    cancelled: "#ef9a9a",
    pending: "#bbdefb",
}
